import React from 'react'
import classnames from 'classnames'

export const Input = (props) => {
  const { input, groupClass, showLabel = false, values, errors } = props
  const { name, label, id, required } = input
  const error = errors[name]

  return (
    <div className={classnames('form__group', groupClass, { 'form__group--required' : required, 'form__group--danger' : error, 'form__group--labeled' : showLabel })}>
      <label htmlFor={id} className="form__label">
        { required && <span className="form__required">*</span> }{label}
      </label>
      <input
        { ...input }
        value = {values[name] || ''}
        className={classnames('form__control', { 'form__group--danger' : error })}
        aria-describedby={`form__${name}`}
        placeholder={label} />
    </div>
  )
}

export default Input



/** WEBPACK FOOTER **
 ** ../app/components/common/Input.jsx
 **/